module.exports = __webpack_public_path__ + "static/retmes-ai-card-5f9b3128c28e2f41c2e7f96f98657f01.png";